import { createTemplate } from '../types';
import { Trigger } from './Trigger';
import { Panel } from './Panel';
import { getStyles } from './styles';

export default createTemplate({ Trigger, Panel, getStyles });
